import React, { FC, useCallback, useEffect, useState } from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import AuthorsItem from '../AuthorsItem/AuthorsItem';
import { useSnackbar } from 'notistack';
import { useActivateAuthorMutation, useDeactivateAuthorMutation, useAuthorsListQuery } from '../gql/authors.generated';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Author } from '@graphql/types'
import { AuthorsListContentProps } from './AuthorsListContentProps';
import {AUTHORS_LIST_CONTENT} from './AuthorsListContent.consts'


const AuthorsListContent: FC<AuthorsListContentProps> = ({ status, search, selectedEditor }) => {
    const [isEmptyList, setIsEmptyList] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const newstatus = status ? null : false;

    const { data, fetchMore, refetch } = useAuthorsListQuery({
        variables: {
            status: newstatus,
            search: search || null,
            editorId: selectedEditor || null,
        },
        onCompleted: data => {
            setIsEmptyList(!data.authors_list?.edges.length);
        },
        notifyOnNetworkStatusChange: true,
    });
    console.log(data)
    useEffect(() => {
        void refetch({
            status: newstatus,
            search: search || null,
            editorId: selectedEditor || null
        });
    }, [status, search, selectedEditor, refetch]);

    const fetchMoreData = useCallback(() => {
        if (!data?.authors_list?.pageInfo.hasNextPage) return;

        void fetchMore({
            variables: {
                after: data.authors_list.pageInfo.endCursor,
                status: newstatus,
                search: search || null,
                editorId: selectedEditor || null
            },
            updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prev;

                return {
                  authors_list: {
                        ...fetchMoreResult.authors_list,
                        edges: [...prev.authors_list.edges, ...fetchMoreResult.authors_list.edges],
                    },
                };
            },
        });
    }, [data?.authors_list?.pageInfo.hasNextPage, data?.authors_list?.pageInfo.endCursor, fetchMore, status, search, selectedEditor]);

  const [deactivateAuthor] = useDeactivateAuthorMutation();
  const [activateAuthor] = useActivateAuthorMutation();

  const deactivateAuthorAction = useCallback(
    async (uid: string) => {
      try {
        await deactivateAuthor({
          variables: {
            data: {
              authorUid: uid,
            },
          },
        });
        void refetch({
          status: newstatus,
          search: search || null,
          editorId: selectedEditor || null,
        });
      } catch (error) {
        enqueueSnackbar(AUTHORS_LIST_CONTENT.errorDeactivate, { variant: 'error' });
      }
    },
    [deactivateAuthor, status, search, selectedEditor, refetch, enqueueSnackbar]
  );

  const activateAuthorAction = useCallback(
    async (uid: string) => {
      try {
        await activateAuthor({
          variables: {
            data: {
              authorUid: uid,
            },
          },
        });
        void refetch({
          status: newstatus,
          search: search || null,
          editorId: selectedEditor || null,
        });
      } catch (error) {
        enqueueSnackbar(AUTHORS_LIST_CONTENT.errorActivate, { variant: 'error' });
      }
    },
    [activateAuthor, status, search, selectedEditor, refetch, enqueueSnackbar]
  );

    return (
        <>
            {!isEmptyList ? (
                <InfiniteScroll
                    dataLength={data?.authors_list?.edges?.length || 0}
                    next={fetchMoreData}
                    hasMore={!!data?.authors_list?.pageInfo.hasNextPage}
                    loader={<LinearProgress color="primary" />}
                    height="78vh"
                >
                    <Box paddingRight="15px">
                        {data?.authors_list?.edges.map((edge, index) => (
                            <AuthorsItem
                                author={edge?.node as Author}
                                key={`${edge?.node?.uid}-${index}`}
                                deactivateAuthorAction={deactivateAuthorAction}
                                activateAuthorAction={activateAuthorAction}
                            />
                        ))}
                    </Box>
                </InfiniteScroll>
            ) : (
                <Box marginTop="15px">
                    <Typography variant="h2">{AUTHORS_LIST_CONTENT.authorsNone}</Typography>
                </Box>
            )}
        </>
    );
};

export default AuthorsListContent;